import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { OutpostEvent, OutpostEventListResponse } from '../../../../../../../typings/outpost';
import Badge from '../../../common/base/Badge';
import Text from '../../../common/base/Text';
import DisplayDate from '../../../common/DisplayDate';
import { EmptyResults, StyledEmptyStateWrapper } from '../../../common/EmptyState';
import { Div } from '../../../common/helpers/StyledUtils';
import Table from '../../../common/Table/Table';
import Chip from '../../../common/base/Chip';
import { getOutpostTenantLabel, useOutpostTenantsById } from '../utils/tenantDisplay';
const OperatorEventsList = t0 => {
  const $ = _c(28);
  const {
    events_response,
    loading,
    onNextPage,
    onPreviousPage,
    onRowSelected
  } = t0;
  const [current_page, setCurrentPage] = useState(1);
  let t1;
  if ($[0] !== events_response?.models) {
    t1 = events_response?.models || [];
    $[0] = events_response?.models;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const events = t1;
  const getPayload = _temp;
  let t2;
  if ($[2] !== events) {
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = event_0 => event_0.data?.tenant_id || getPayload(event_0)?.destination?.tenant_id;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    t2 = events.map(t3);
    $[2] = events;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const tenant_ids = t2;
  const {
    tenants_by_id
  } = useOutpostTenantsById(tenant_ids);
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = ["Time", "Topic", "Tenant", "Destination"];
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const headers = t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [{
      min: 152,
      max: 152
    }, {
      min: 240
    }, {
      min: 200
    }, {
      min: 240
    }];
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const widths = t4;
  let t5;
  if ($[7] !== events || $[8] !== loading || $[9] !== tenants_by_id) {
    t5 = loading ? [] : events.map(event_1 => {
      const destination = getPayload(event_1)?.destination;
      const tenant_id = event_1.data?.tenant_id || destination?.tenant_id;
      return {
        id: event_1.id,
        fields: [<DisplayDate key={`${event_1.id}-time`} date={event_1.time} show_timezone={false} />, <Badge key={`${event_1.id}-topic`} subtle={true} neutral={true}>{event_1.topic}</Badge>, tenant_id ? <Chip outline={true} label={getOutpostTenantLabel(tenant_id, tenants_by_id[tenant_id])} to={`/tenants/${tenant_id}`} key={`${event_1.id}-tenant`} /> : <Text key={`${event_1.id}-tenant`} muted={true}>—</Text>, destination ? <Chip outline={true} label={destination.id} to={`/tenants/${tenant_id}/destinations/${destination.id}`} key={`${event_1.id}-destination`} mono={true} /> : <Text key={`${event_1.id}-destination`} muted={true}>—</Text>]
      };
    });
    $[7] = events;
    $[8] = loading;
    $[9] = tenants_by_id;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const rows = t5;
  if (events.length === 0 && !loading) {
    let t6;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <StyledEmptyStateWrapper><EmptyResults label="There have been no operator events yet." /></StyledEmptyStateWrapper>;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    return t6;
  }
  const t6 = rows as any;
  let t7;
  if ($[12] !== current_page) {
    t7 = {
      current_page,
      page_size: 25,
      entity_name: "operator events"
    };
    $[12] = current_page;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== current_page || $[15] !== onNextPage) {
    t8 = onNextPage ? () => {
      onNextPage();
      setCurrentPage(current_page + 1);
    } : undefined;
    $[14] = current_page;
    $[15] = onNextPage;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== current_page || $[18] !== onPreviousPage) {
    t9 = onPreviousPage ? () => {
      onPreviousPage();
      setCurrentPage(current_page - 1);
    } : undefined;
    $[17] = current_page;
    $[18] = onPreviousPage;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const t10 = events_response?.models.length;
  let t11;
  if ($[20] !== loading || $[21] !== onRowSelected || $[22] !== t10 || $[23] !== t6 || $[24] !== t7 || $[25] !== t8 || $[26] !== t9) {
    t11 = <Div h={100}><Table fill={true} list={true} headers={headers} widths={widths} top_offset={52} rows={t6} loading={loading} loading_title="Loading operator events" loading_message="Loading operator event history..." onRowSelected={onRowSelected} pagination={t7} onNextPage={t8} onPreviousPage={t9} current_count={t10} /></Div>;
    $[20] = loading;
    $[21] = onRowSelected;
    $[22] = t10;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  return t11;
};
export default OperatorEventsList;
function _temp(event) {
  return event.data?.data ?? event.data;
}